import { models } from 'cesg-shared';
import { useI18n } from 'vue-i18n';

const AtaChangelog = models.ChangelogOptions.ATA;

type ChangelogOptions = typeof models.ChangelogOptions;
type ChangelogTypes = ChangelogOptions[keyof ChangelogOptions]['type'];

const ChangelogBase = ['changelogs'];

const tGeneralPath = (...rest: string[]) =>
  [...ChangelogBase, 'general', ...rest].join('.');

const tTypesTypeAction = (type: ChangelogTypes, action: string) =>
  [...ChangelogBase, 'types', type, action].join('.');

export function useChangelogs<Type extends ChangelogTypes>(type: Type) {
  const { t } = useI18n();

  function translateComment(changes: { from?: string; to?: string }) {
    return t(tTypesTypeAction(type, 'commentChanged'), {
      from: changes?.from || '',
      to: changes?.to || '',
    });
  }

  function translateStatusChange(changes: { from?: string; to?: string }) {
    return t(tTypesTypeAction(type, 'statusChanged'), {
      from: changes?.from ? t(changes.from) : t(tGeneralPath('noStatus')),
      to: changes?.to ? t(changes.to) : t(tGeneralPath('noStatus')),
    });
  }

  function translate(action: string, changes: { from?: string; to?: string }) {
    switch (action) {
      case AtaChangelog.actions.commentChanged:
        return translateComment(changes);
      case AtaChangelog.actions.statusChanged:
        return translateStatusChange(changes);
      default:
        return t([ChangelogBase, 'unknown'].join('.'), {
          type: action,
          changes: JSON.stringify(changes),
        });
    }
  }

  function changeToString(action: string, change: unknown) {
    return translate(action, change as { from?: string; to?: string });
  }

  return { tChangelog: changeToString };
}
